import Axios from 'axios'

export const http = Axios.create({
  withCredentials: true,
  baseURL: `${process.env.VUE_APP_BASE_URL}/api`
})
